/* Source: DEV-484 polish pass v1 | 2026-10-15 | image arrival, add-to-cart feedback, header bag pulse, newest cart line.
   Progressive: if this file never runs, every image shows and every button works exactly as before. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Image arrival: card photos fade in when they finish loading; anything already loaded shows at once. */
  function arrive(img) {
    if (img.classList.contains('is-arrived')) return;
    if (img.complete && img.naturalWidth > 0) { img.classList.add('is-arrived'); return; }
    var done = function () { img.classList.add('is-arrived'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    setTimeout(done, 4000);
  }
  function scan(scope) {
    var imgs = (scope || document).querySelectorAll('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    for (var i = 0; i < imgs.length; i++) arrive(imgs[i]);
  }
  if (!reduce) {
    root.classList.add('hea-fade');
    scan();
    document.addEventListener('DOMContentLoaded', function () { scan(); });
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1) { if (n.matches && n.matches('.ProductItem__Image')) arrive(n); else if (n.querySelectorAll) scan(n); }
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }

  /* Add to Cart: "Adding" while the request runs, a drawn check and "Added" when it lands.
     The slide-out cart (cart-drawer.js) owns the request: it marks the button .is-loading and puts its own
     label back when done. This follows that state instead of the click, so the drawer always restores the
     real label first and this only decorates around it. */
  var CHECK = '<svg class="hea-atc__check" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7.5l3.2 3L12 3.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var landed = false;
  document.addEventListener('cart:change', function () { landed = true; });
  function watchButton(btn) {
    if (btn.dataset.heaWatched) return;
    btn.dataset.heaWatched = '1';
    var busy = false, rest = null, timer = null;
    new MutationObserver(function () {
      var loading = btn.classList.contains('is-loading');
      if (loading && !busy) {
        busy = true; landed = false;
        clearTimeout(timer);
        rest = btn.innerHTML;
        btn.classList.add('hea-atc--busy');
        btn.setAttribute('aria-busy', 'true');
        var l = btn.querySelector('span');
        if (l) l.textContent = 'Adding';
      } else if (!loading && busy) {
        busy = false;
        btn.classList.remove('hea-atc--busy');
        btn.removeAttribute('aria-busy');
        if (!landed) return;
        var label = btn.querySelector('span');
        if (!label) return;
        var restLabel = label.innerHTML;
        label.innerHTML = CHECK + 'Added';
        timer = setTimeout(function () { var l2 = btn.querySelector('span'); if (l2) l2.innerHTML = restLabel; }, 1800);
      }
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  }
  function watchAll() { var b = document.querySelectorAll('.ProductForm__AddToCart'); for (var i = 0; i < b.length; i++) watchButton(b[i]); }
  watchAll();
  document.addEventListener('DOMContentLoaded', watchAll);

  /* Header bag dot pulses once when the count goes up; the newest drawer line warms briefly. */
  var countEl = document.querySelector('[data-cart-count], .Header__CartCount');
  var lastCount = countEl ? parseInt(countEl.textContent, 10) || 0 : null;
  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    var count = cart.item_count || 0;
    if (lastCount !== null && count > lastCount && !reduce) {
      var dot = document.querySelector('.Header__CartDot');
      if (dot) { dot.classList.remove('hea-bump'); void dot.offsetWidth; dot.classList.add('hea-bump'); }
      requestAnimationFrame(function () {
        var first = document.querySelector('.cart-drawer__line[data-line="1"]');
        if (first) { first.classList.remove('hea-line--new'); void first.offsetWidth; first.classList.add('hea-line--new'); }
      });
    }
    lastCount = count;
  });
})();
